import { Flex } from "components/Base";
import UserBadge from "global/Profile/UserBadge";
import profileStore from "lib/stores/entities/profile";
import Sidebar from "./Sidebar";
import useProfileStore from "../profileStore";

function SideContent() {
  const profile = profileStore((s) => s.user);
  const setProfileState = useProfileStore((s) => s.setProfileState);

  if (!profile) {
    return null;
  }

  return (
    <Flex as="aside" direction="column" w="388px" gap="18px">
      <UserBadge
        color={profile.badge.color}
        name={profile.badge.name}
        points={profile.total_point}
        onClick={() => setProfileState("point-history")}
      />
      <Sidebar />
    </Flex>
  );
}

export default SideContent;
